import { useCallback, useState } from 'react'

export const useNotificationPermission = () => {
  const [notificationPermission, setNotificationPermission] = useState<NotificationPermission>(Notification.permission)

  const requestPermission = useCallback(() => {
    Notification.requestPermission().then(permission => {
      setNotificationPermission(permission)
    })
  }, [])

  return {
    notificationPermission,
    requestPermission
  }
}
